import { openWorkspaceDb } from '@/offline/db'
import { atomicLocalWrite, buildOperation } from '@/offline/queue'
import { pushOutbox, type PushSummary } from '@/offline/sync'
import { supabaseTransport } from '@/offline/transport'
import type { BuiltPayment } from './paymentPayload'

/** Record a partial receipt locally (with its outbox op) then sync. */
export async function savePayment(workspaceId: string, built: BuiltPayment): Promise<PushSummary> {
  const db = openWorkspaceDb(workspaceId)
  const op = buildOperation({
    workspace_id: workspaceId,
    entity_id: built.payment.id,
    entity_type: 'payment',
    expected_revision: null,
    action: 'payment.create',
    payload: built.payload,
  })
  await atomicLocalWrite(db, [db.payments], async () => {
    await db.payments.add(built.payment)
  }, op)
  return pushOutbox(db, supabaseTransport())
}
